/**
 * Public API client — resolves slug-based putty.me URLs to entity payloads.
 *
 * Mirrors `/v1/public/...` routes in `production/api/src/api/public/routes.ts`.
 * These endpoints are auth-optional: if the viewer has a logged-in session
 * the bearer is sent (giving access to private content the user owns); if
 * not, the request still succeeds but only public-shared rows return
 * meaningful payloads.
 */
import { apiGet } from "./base-query-api";
export async function resolveName(name) {
    const res = await apiGet(`/public/resolve/${encodeURIComponent(name)}`);
    if (!res.success || !res.data) {
        throw new Error(res.error ?? "Failed to resolve name");
    }
    return res.data;
}
export async function resolveCollection(parentName, collectionSlug) {
    const res = await apiGet(`/public/resolve/${encodeURIComponent(parentName)}/${encodeURIComponent(collectionSlug)}`);
    if (!res.success || !res.data) {
        throw new Error(res.error ?? "Failed to resolve collection");
    }
    return res.data;
}
export async function resolveStandaloneCollection(slug) {
    const res = await apiGet(`/public/collection/${encodeURIComponent(slug)}`);
    if (!res.success || !res.data) {
        throw new Error(res.error ?? "Failed to resolve standalone collection");
    }
    return res.data;
}
export async function resolveBlockBySlug(slug) {
    const res = await apiGet(`/public/block/${encodeURIComponent(slug)}`);
    if (!res.success || !res.data) {
        throw new Error(res.error ?? "Failed to resolve block");
    }
    return res.data;
}
